module.exports = __webpack_public_path__ + "static/media/20ECE13.8e89e118.jpg";